import { AxiosResponse } from "axios";
import { ZodType } from "zod";

export const parseResponse =
  <T>(type: ZodType<T, any, any>) =>
  (response: AxiosResponse<unknown>) => {
    return type.parse(response.data) as T;
  };
